import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";
import axios from 'axios';


import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";

import Popup01 from "../../pages/popup/Popup01"

import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';

import { GoogleMap, LoadScript, KmlLayer } from '@react-google-maps/api';
import PopupLicence from '../popup/PopupLicence';
import { gtag } from '../../analytics';

export default function Education() {
    const location = useLocation();
    
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { mbData } = useSelector((s) => s.usersReducer);
    const lang = useSelector(state => state.langReducer.lang);

    const mapRef = useRef(null);
    const [answerView, setAnswerView] = useState(Array(10).fill(false));

    const [pin, setPin] = useState([]);
    const [searchView, setSearchView] = useState('');
    const [questionSample, setQuestionSample] = useState([
        'Q1. UModeler X School 라이선스는 누구에게 제공되나요?',
        'Q2. UModeler와 파트너십을 체결한 학교의 학생 및 교사는 어떻게 라이선스를 발급받을 수 있나요?',
        'Q3. UModeler X School 라이선스를 통해 어떤 제품을 사용할 수 있나요?',
        'Q4. 라이선스의 유효 기간은 어떻게 되며, 갱신은 어떻게 이루어지나요?',
        'Q5. UModeler X School 라이선스는 어떻게 신청하나요?',
    ]);


    const [questionSampleEn, setQuestionSampleEn] = useState([
        'Q1. Who is eligible for the UModeler X School License?',
        'Q2. How can students and educators from UModeler partner institutions obtain the license? ',
        'Q3. Which product is provided under the UModeler X School License?',
        'Q4. How long is the license valid, and how can it be renewed?',
        'Q5. How can I apply for the UModeler X School License?',
    ]);
    const answerSample = [
        [
            <>
                Pro는 Plus의 모든 기능을 포함하며, 추가적으로 블렌드 쉐입 모드, Curve 컴포넌트, Quadify 툴, Edge Constraints 툴, Text to 3D 컴포넌트 등 더 많은 확장 기능을 제공합니다. 또한 구독 기간 중 지속적인 기능 업데이트가 이루어집니다.
            </>,
            <>
                Pro는 구독 모델로 UModeler 웹사이트에서 누구나 제한 없이 구독할 수 있습니다. 반면, Plus는 Unity Asset Store에서 구매 가능하며, 연 매출 20만 달러 미만의 개인 및 기업만 사용할 수 있습니다.
            </>,
            <>
                더 자세한 비교는<span>공식 매뉴얼의 FAQ</span>를 참고해 주세요.
            </>
        ],
        /* [
            <>
                기존 UModeler 혹은 Plus를 사용 중인 경우 Pro, Art Pass, All-In-One 연 구독 시 특별 업그레이드 할인 혜택이 제공됩니다. (쿠폰과 중복 가능)
            </>,
            <>
                업그레이드 할인을 위해서는<span onClick={navigate(routes.Price)}>가격 페이지</span>를 참고해 주세요.
            </>
        ], */
    ];
    const filteredPins = pin.filter((pin) => 
        pin.toLowerCase().includes(searchView.toLowerCase())
    );

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const pinsKo = ["남산공원", "바다", "울릉도", "가가", "나나", "다다"];
        const pinsEng = ["Namsan Park", "Sea", "Ulneungdo", "AA", "BB", "CC"];
        
        if (lang === 0) {
            setPin([...pinsKo].sort((a, b) => a.localeCompare(b, 'ko-KR'))); // 한국어 가나다순
        } else {
            setPin([...pinsEng].sort((a, b) => a.localeCompare(b, 'en-US'))); // 영어 ABC순
        }
    }, [lang]);

    const LicensePop = () => {
        dispatch(open({
            component: 
                <PopupLicence
                    max_width={'500px'}
                    x_btn={true}
                    button={lang === 0 ? '인증번호 요청' : 'Request Verification Code'}
                    buttonCancel={lang === 0 ? '취소' : 'Cancel'}
                />
        }));
    }
    const ClickAnswerView = (index) => {
        const newAnswerView = [...answerView];
        newAnswerView[index] = !newAnswerView[index];
        setAnswerView(newAnswerView);
    };
    return (
        <>
            <div className="main_back" style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                <div className="main_part padding education" style={{ width: '100%', maxWidth: '1200px', padding: '20px' }}>

                    <div
                        className="video_view main"
                    >
                        <div className="banner_text_box" style={{ marginTop: 0 }}>
                            <p style={{ color: '#000' }}>
                                UModeler X School
                            </p>
                            <div className="sub_title_box">
                                {lang === 0 ?
                                    <>
                                        전 세계 학교의 학생과 교사를 위한 <span style={{ fontWeight: 'bold', color: '#4285F4', fontSize: 'inherit' }}>UModeler X 무료 라이선스!</span>
                                    </>
                                    :
                                    <>
                                        <span style={{ fontWeight: 'bold', color: '#4285F4', fontSize: 'inherit' }}>Free UModeler X License</span> for Students and Teachers Worldwide!
                                    </>
                                }
                            </div>

                            <button
                                type="button"
                                className="custom_btn price_page_top"
                                style={{ minWidth: 'unset', width: 205 }}
                                onClick={() => {
                                    gtag('event', 'school_register', {
                                        'event_category': 'engagement',
                                        'event_label': lang === 0 ? '학교 신청하기' : 'School Registration'
                                    });
                                    LicensePop();
                                }}
                            >
                                {lang === 0 ?
                                    <>
                                        신청하기
                                    </>
                                    :
                                    <>
                                        Apply Now
                                    </>
                                }
                            </button>

                        </div>
                    </div>
                </div>
            </div> {/* 메인 div */}
            <div className="main_back">
                <div className="main_part padding">
                    <div className="title_box">
                        {lang === 0 ? '자주 묻는 질문' : 'FAQ'}
                    </div><br /><br />

                    <div className="question_box">
                        {questionSample.map((x, i) => (
                            <div
                                key={i}
                                className={`question_list ${answerView[i] ? 'on' : ''}`}
                                onClick={() => {
                                    ClickAnswerView(i)
                                    /* console.log(i); */
                                }}
                            >
                                <b>{lang === 0 ? x : questionSampleEn[i]}</b>

                                {answerView[i] &&
                                    <div className="answer">
                                        <div
                                            className="answer_text_box"
                                            onClick={(e) => {
                                                e.stopPropagation()
                                            }}
                                        >
                                            {i === 0 &&
                                                <>
                                                    <div className="text">
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    UModeler X School 라이선스는 전 세계의 초중고 및 대학교 학생과 교사라면 누구나 신청할 수 있습니다. 
                                                                </>
                                                                :
                                                                <>
                                                                    The UModeler X School License is available to all students and educators at primary, secondary, and higher education institutions worldwide.
                                                                </>
                                                            }

                                                        </span>
                                                    </div>

                                                    <div className="text">
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    신청 시에는 일반적으로 학교 이메일 주소 또는 재학/재직을 증명할 수 있는 자료(예: 학생증, 교직원증 등)가 필요합니다.
                                                                </>
                                                                :
                                                                <>
                                                                    To apply, you will typically need to provide a valid school email address or proof of enrollment or employment (e.g., student ID, faculty/staff ID, etc.).
                                                                </>
                                                            }


                                                        </span>
                                                    </div>

                                                    <div className="text">
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    단, UModeler와 파트너십을 맺은 학교의 경우, 해당 학교 도메인의 이메일 주소만으로 인증이 가능하며, 간편하게 1년 라이선스를 발급받을 수 있습니다.
                                                                </>
                                                                :
                                                                <>
                                                                If your school is a UModeler partner institution, you can easily receive a one-year license simply by verifying your school domain email address, without additional documentation.
                                                                </>
                                                            }


                                                        </span>
                                                    </div>
                                                </>
                                            }

                                            {i === 1 &&
                                                <>
                                                    <div className="text">
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    파트너로 지정된 학교에 소속된 학생이나 교사는 학교 이메일 주소 인증만으로 간단히 라이선스를 받을 수 있으며, 별도 증빙 없이 1년간 자동 발급됩니다. 예: @abcuniversity.edu
                                                                </>
                                                                :
                                                                <>
                                                                    Students and educators at officially designated partner schools can obtain the license by verifying their school email address only. Once verified, the license is automatically issued for one year without the need to submit additional documents. Example: @abcuniversity.edu
                                                                </>
                                                            }
                                                        </span>
                                                    </div>
                                                    <div className="text">
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                <span
                                                                    onClick={() => {
                                                                                LicensePop()
                                                                        }}
                                                                    >
                                                                    School 라이선스 신청하기
                                                                    </span>    
                                                                </>
                                                                :
                                                                <>
                                                                <span
                                                                    onClick={() => {
                                                                                LicensePop()
                                                                        }}
                                                                    >
                                                                    Apply for School License
                                                                    </span>                                                                    
                                                                </>
                                                            }
                                                        </span>
                                                    </div>
                                                </>
                                            }

                                            {i === 2 &&
                                                <>
                                                    <div className="text">
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    UModeler X Pro 버전이 제공되며, 교육 및 학습 목적으로만 사용 가능합니다. 상업적 사용은 제한됩니다.
                                                                </>
                                                                :
                                                                <>
                                                                    The School License grants access to the UModeler X Pro version, which includes advanced features. It is provided strictly for educational and learning purposes only and cannot be used for commercial activities.
                                                                </>
                                                            }


                                                        </span>
                                                    </div>
                                                </>
                                            }

                                            {i === 3 &&
                                                <>
                                                    <div className="text">
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    기본적으로 1년간 사용 가능하며, 기간이 끝나기 전에 학교 재학/재직 상태가 유지된다면 연장 신청을 통해 계속 사용할 수 있습니다.                                                                    
                                                                </>
                                                                :
                                                                <>
                                                                    The license is valid for one year. If you are still enrolled or employed at your institution when the license expires, you may renew it by reapplying.
                                                                </>
                                                            }
                                                        </span>
                                                    </div>
                                                
                                                    <div className="text">
                                                        <span>
                                                            {lang === 0 ?
                                                                <>
                                                                    파트너 학교 이메일 보유자도 라이선스를 매년 갱신해야 하며, 매번 유효한 학교 이메일 주소로 인증이 필요합니다. 라이선스 갱신은 파트너십이 유지되는 기간 동안 매년 가능합니다.
                                                                </>
                                                                :
                                                                <>
                                                                    Even for partner school email holders, the license must be renewed annually, and a valid school email address is required each time for verification. Renewals are available annually during the active partnership period.
                                                                </>
                                                            }


                                                        </span>
                                                    </div>
                                                </>
                                            }

                                            {i === 4 &&
                                                <>
                                                    <div className="text">
                                                        <span>
                                                            {lang === 0 ?
                                                                <> 
                                                                <span
                                                                    onClick={() => {
                                                                                LicensePop()
                                                                        }}
                                                                    >
                                                                    School 라이선스 신청 페이지
                                                                    </span>에서 신청할 수 있습니다. 학교 이메일 인증 또는 증빙 서류 업로드가 필요하며, 교사의 경우 여러 명의 학생을 위한 단체 신청도 지원됩니다.
                                                                </>
                                                                :
                                                                <>
                                                                You can apply through the 
                                                                <span
                                                                    onClick={() => {
                                                                                LicensePop()
                                                                        }}
                                                                    >
                                                                    School License Application Page
                                                                    </span> on the official UModeler website. Verification via school email address or submission of proof documents is required. For educators, bulk license applications for multiple students are also supported.
                                                                </>
                                                            }
                                                        </span>
                                                    </div>
                                                </>
                                            } 
                                        </div>
                                    </div>
                                }
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
                hideProgressBar
            />
        </>
    );
}
